import type { ISceneObj } from '../../../types/SceneType';

function summarizeExpression(value: unknown): string {
	if (value == null) return 'always';
	if (typeof value !== 'object') return String(value);
	const entries = Object.entries(value as Record<string, unknown>);
	if (!entries.length) return 'always';
	const [operator, operand] = entries[0];
	if ((operator === 'and' || operator === 'or') && Array.isArray(operand)) {
		return operand.map(summarizeExpression).join(operator === 'and' ? ' and ' : ' or ');
	}
	if (operator === 'not') return `not (${summarizeExpression(operand)})`;
	if (Array.isArray(operand)) {
		return `${summarizeExpression(operand[0])} ${operator} ${summarizeExpression(operand[1])}`;
	}
	if (operator === 'r') return String(operand);
	return `${operator} ${summarizeExpression(operand)}`;
}

function summarizeAction(action: unknown): string {
	if (!action || typeof action !== 'object') return String(action);
	const record = action as Record<string, unknown>;
	if (record.if && Array.isArray(record.do)) {
		return `if ${summarizeExpression(record.if)}, run ${record.do.length} nested action(s)`;
	}
	if (typeof record.method === 'string') return record.method;
	if (typeof record.type === 'string') return record.type;
	const key = Object.keys(record).find((item) => !item.startsWith('_'));
	return key || 'action';
}

export function buildSceneSemanticPreview(scene: ISceneObj): string {
	const lines = [
		`Flow: ${scene._meta?.name || 'Untitled Flow'}`,
		`When ${summarizeExpression(scene.if)}`,
	];
	const actions = Array.isArray(scene.do) ? scene.do : [];
	if (actions.length) {
		lines.push('Then:');
		actions.forEach((action, index) => lines.push(`  ${index + 1}. ${summarizeAction(action)}`));
	} else {
		lines.push('Then: no actions');
	}
	const otherwise = Array.isArray(scene.else) ? scene.else : [];
	if (otherwise.length) {
		lines.push('Otherwise:');
		otherwise.forEach((action, index) => lines.push(`  ${index + 1}. ${summarizeAction(action)}`));
	}
	return lines.join('\n');
}
